(function() {
  angular.module('registration')
    .service('registrationUserService', function() {
      let registrationModel = {};
      //This is our initial value, don't ever let anyone touch it (never return this object)
      let createUserModelInitial = { challengeResponses: [{}, {}, {}]};
      let createUserModel = angular.copy(createUserModelInitial);
      return {
        registrationModel: function(_registrationModel) {
          if (_registrationModel !== undefined) {
            registrationModel = angular.copy(_registrationModel);
          }
          return registrationModel;
        },
        createUserModel: function(_createUserModel) {
          if (_createUserModel !== undefined) {
            /* Merge whatever is passed in into an empty object and then merge in the
            object with the challengeResponses */
            createUserModel = _.merge({}, _createUserModel, createUserModelInitial);
          }
          return createUserModel;
        },
        init: function() {
          registrationModel = {};
          createUserModel = angular.copy(createUserModelInitial);
        },
        userProjection: function() {
          return _.pick(_.merge({}, registrationModel, createUserModel), [
            'taxIds',
            'firstName',
            'lastName',
            'userId',
            'password',
            'unverifiedEmail',
            'challengeResponses',
            'id',
            'emailVerificationGuid'
          ]);
        }
      };
    });
})();
